export default __webpack_public_path__ + "static/media/fluent-emoji-flat_1st-place-medal.9b7b9d9e.svg";